import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSkeleton } from "../../../hooks/useSkeleton";

import {
    Card,
    CardBody
} from "../../../../_metronic/_partials/controls";
import {
    Button,
    MuiThemeProvider,
    createMuiTheme,
    Box, Typography
} from "@material-ui/core";
import { deleteContact, getContactById } from "../../../../api/contact";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

const theme = createMuiTheme({
    palette: {
        secondary: {
            main: "#F64E60",
        },
    },
});

function getEmptyContact() {
    return {
        fullName: "",
        email: "",
        phone: "",
        info: "",
        reason: ""
    }
}

export const InfoItem = ({ label, value, h6 = false, row = false }) => {

    return (
        <Box className={`d-flex ${row ? '' : 'flex-column'}`} style={{ alignItems: row ? "center" : "" }}>
            <Typography variant={h6 ? "h6" : "h5"} style={{ fontWeight: 'bold', marginBottom: '8px', marginTop: "12px" }}>
                {label}
            </Typography>
            <Typography style={{
                marginBottom: row ? '8px' : '16xp',
                color: 'rgba(61, 60, 60, 0.38)',
                opacity: 1,
                marginLeft: row ? '8px' : '',
                marginTop: row ? '12px' : ''
            }}>
                <span>{value || '---'}</span>
            </Typography>
        </Box>
    );
};

export default function WatchContactPage() {
    const history = useHistory();
    const {
        isLoading: isLoadingData,
        disableLoading: disableLoadingData,
        ContentSkeleton
    } = useSkeleton();
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    const contactId = useParams().id;
    const [contact, setContact] = useState(getEmptyContact())


    useEffect(() => {

        if (!contactId) {
            disableLoadingData();
            return;
        }

        getContactById(contactId)
            .then((res) => {
                setContact(res.data);
                disableLoadingData();
            })
            .catch((error) => {
                alertError({ error: error, customMessage: "Could not get contact." });
                history.push("/contacts");
            });

    }, [contactId, disableLoadingData, history]);

    if (isLoadingData)
        return <ContentSkeleton />;

    return (
        <>
            <Card>
                <CardBody>
                    <InfoItem label="Full name" value={contact.fullName} />
                    <InfoItem label="Email" value={contact.email} />
                    <InfoItem label="Information" value={contact.info} />
                </CardBody>


            </Card>

            <Button
                onClick={() => history.push("/contacts")}
                variant="outlined"
                style={{ marginRight: 20 }}
            >
                Back
            </Button>

            {
                contactId && (
                    <>
                        <MuiThemeProvider theme={theme}>
                            <Button
                                onClick={() => setOpenConfirmDialog(true)}
                                variant="outlined"
                                color="secondary"
                            >
                                Delete Contact
                            </Button>
                        </MuiThemeProvider>

                        <ConfirmDialog
                            title="Are you sure you want to delete this contact?"
                            open={openConfirmDialog}
                            setOpen={setOpenConfirmDialog}
                            onConfirm={() => {
                                deleteContact(contactId)
                                    .then((res) => {
                                        alertSuccess({
                                            title: "Deleted!",
                                            customMessage: "Contact deleted successfully",
                                        });
                                        history.push("/contacts");
                                    })
                                    .catch((error) => {
                                        alertError({
                                            error: error,
                                            customMessage: "Could not delete contact.",
                                        });
                                    });
                            }}
                        />
                    </>
                )
            }
        </>
    )
}